//
// utilisé pour gérer la compatibilité avec d’autres jQuery (tag externes) et Bootstrap
//
define('jqueryShim',['jquery'],function($){
    window.jQuery = $;
});
